<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<div mat-dialog-container>
  <div mat-dialog-title>
    @if (data.invitation.id) {
    <span>Edit</span>
    }
    @if (!data.invitation.id) {
    <span>Create</span>
    }
    an Invitation to this MSEL
    &nbsp;
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.invitation !== undefined && data.invitation !== null) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        @if (!data.invitation.id) {
        <mat-form-field class="full-width">
          <mat-label>Team</mat-label>
          <mat-select placeholder="Team" [(ngModel)]="data.invitation.teamId">
            @for (team of data.teamList; track team) {
            <mat-option [value]="team.id" title="{{ team.shortName }} - {{ team.name }}">
              {{ team.shortName }} - {{ team.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        @if (data.invitation.id) {
        <span>Team <br />{{ getTeamName(data.invitation.teamId) }}<br />&nbsp;</span>
        }
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>User emails end with ...</mat-label>
          <input type="text"
            title="If entered, the users' email addresses must end with this value.  The entered value can be a complete email address or a partial email address that is longer than 3 characters and contains an '@'. (i.e. @provider.com)"
            matInput [(ngModel)]="data.invitation.emailDomain">
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div class="single-detail center-self">
        <mat-form-field class="datetime-field">
          <mat-label>Expiration Date/Time</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker" [(ngModel)]="data.invitation.expirationDateTime"
            style="display: none;">
          <!-- <datetime-picker> -->
          <span (click)="picker.open()">
            {{ data.invitation.expirationDateTime | date: 'dd MMM yyyy HH:mm' }} {{ getTimezoneAbbr() }}
          </span>
          <mat-datepicker-toggle matSuffix title="Choose Date/Time" [for]="picker">
          </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]=true [showSeconds]=false [stepHour]=1 [stepMinute]=5
            [stepSecond]=1 [touchUi]=false [enableMeridian]=true [disableMinute]=false [hideTime]=false
            [color]="'warn'">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Maximum number of users allowed to use this invitation</mat-label>
          <input type="text" matInput [(ngModel)]="data.invitation.maxUsersAllowed">
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-checkbox [disabled]="true" [(ngModel)]="data.invitation.isTeamLeader">Can invite others to this
          team</mat-checkbox>
      </div>
    </div>
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()"
          style="margin-left: 40px;">Save</button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
      </div>
    </div>
  </div>
  }
